require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-smart-money-moves.json") })
        }
      }, "path---es-articles-smart-money-moves");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-smart-money-moves!./.cache/json/es-articles-smart-money-moves.json
// module id = 2242
// module chunks = 231608221292675